import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import * as Sentry from '@sentry/react'

/**
 * UserTracker component
 *
 * Tracks user identity for analytics (GTM) and error monitoring (Sentry).
 * Renders nothing - exists purely for side effects.
 */
export function UserTracker() {
  const user = useAuthStore((state) => state.user)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  useEffect(() => {
    if (isAuthenticated && user?.id) {
      // GTM dataLayer push
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'user_identified',
        user_id: user.id,
        user_role: user.role || null,
        customer_id: user.customerId || null,
        partner_id: user.partnerId || null,
      })

      // Sentry user identification
      Sentry.setUser({
        id: user.id,
        email: user.email,
      })
    } else if (!isAuthenticated) {
      // Clear Sentry user on logout
      Sentry.setUser(null)
    }
  }, [user, isAuthenticated])

  return null
}
